import React, { useRef, useState } from "react";

import Button from "@/components/Atoms/Button";
import Slider from "@/components/Atoms/Slider";

import SlickArrowButton from "@/components/Molecules/SlickArrowButton";

import PackageCard from "./PackageCard";

import { classNameGenerator } from "@/utils";

import styles from "./AllPackagesCarousel.module.scss";

interface AllPackagesCarouselProps {
  packages: any[];
  setShowBookSlotModal: (showBookSlotModal: any) => void;
}

const AllPackagesCarousel: React.FC<AllPackagesCarouselProps> = ({
  packages,
  setShowBookSlotModal,
}) => {
  const sliderRef = useRef(null);

  const [activePackIndex, setActivePackIndex] = useState(0);

  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: packages?.length,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "45px",
        },
      },
    ],
    prevArrow: (
      <SlickArrowButton
        buttonType="prev"
        variant="icon1"
        icon="icon-testimonials-previous"
      />
    ),
    nextArrow: (
      <SlickArrowButton
        buttonType="next"
        variant="icon1"
        icon="icon-testimonials-next"
      />
    ),
  };

  const next = () => {
    sliderRef.current.slickNext();
  };

  const previous = () => {
    sliderRef.current.slickPrev();
  };

  const cls = classNameGenerator(styles);

  const actionButtons = (
    <div className={cls("actionButtons")}>
      <Button
        variant="icon"
        icon="icon-testimonials-previous"
        onClick={previous}
      />
      <Button variant="icon" icon="icon-testimonials-next" onClick={next} />
    </div>
  );

  return (
    <section className={cls("allPackagesCarousel")}>
      <div className={cls("container")}>
        <Slider ref={sliderRef} settings={settings}>
          {packages?.map((pack, index) => (
            <PackageCard
              key={index}
              {...pack}
              setShowBookSlotModal={setShowBookSlotModal}
              index={index}
              activePackIndex={activePackIndex}
              setActivePackIndex={setActivePackIndex}
            />
          ))}
        </Slider>
        {/* {actionButtons} */}
      </div>
    </section>
  );
};

export default AllPackagesCarousel;
